export default __webpack_public_path__ + "static/media/Loot.9fe8abc4.gif";